export default "__VITE_ASSET__88c059b1__"